import { render, staticRenderFns } from "./DocMsg.vue?vue&type=template&id=9003196e&scoped=true"
import script from "./DocMsg.vue?vue&type=script&lang=js"
export * from "./DocMsg.vue?vue&type=script&lang=js"
import style0 from "./DocMsg.vue?vue&type=style&index=0&id=9003196e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9003196e",
  null
  
)

export default component.exports